module.exports = __webpack_public_path__ + "img/logo.eb1b5265.png";